module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"drone_lot.field.lot_name.help":"ชื่อ Lot สำหรับ Drone Model นี้ เช่น L2020-02-1","drone_lot.field.lot_name.placeholder":"เช่น L2020-02-1","drone_lot.field.manufacture_date.help":"วันผลิต Drone Lot นี้ ระบุเพื่อสามารถตรวจสอบการสั่งอะไหล่ได้","drone_lot.field.remark.placeholder":"เช่น Lot นี้มีการเปลี่ยน Supplier ในบางชิ้นส่วน เป็นต้น"}}')
  delete Component.options._Ctor
}
